export * from './translatable';


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/react-instantsearch-core/dist/es/types/index.js
// module id = 964
// module chunks = 0 1 2 3 4 5 6 7 8